 const carousel = document.querySelector('.carousel');
const leftArrow = document.getElementById('leftArrow');
const rightArrow = document.getElementById('rightArrow');

let offset = 0;

function updateCarousel() {
  const containerWidth = document.querySelector('.carousel-wrapper').offsetWidth;
  const itemWidth = carousel.children[0].offsetWidth; // Get item width dynamically
  const totalItems = carousel.children.length;
  const visibleItems = Math.floor(containerWidth / itemWidth);
  const maxOffset = -((totalItems - visibleItems) * itemWidth);

  leftArrow.addEventListener('click', () => {
    offset += itemWidth;
    if (offset > 0) offset = 0;
    carousel.style.transform = `translateX(${offset}px)`;
  });

  rightArrow.addEventListener('click', () => {
    offset -= itemWidth;
    if (offset < maxOffset) offset = maxOffset;
    carousel.style.transform = `translateX(${offset}px)`;
  });
}

// Update carousel on window resize
window.addEventListener('resize', () => {
  offset = 0; // Reset offset
  carousel.style.transform = `translateX(${offset}px)`;
  updateCarousel();
});

// Initial setup
updateCarousel();